(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-bundle-reviews"]) return;
  try {
    
  if (!customElements.get('mo-bundle-reviews')) {
    customElements.define('mo-bundle-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = [...this.querySelectorAll('.mo-bundle-reviews__tab')];
        this.panels = [...this.querySelectorAll('.mo-bundle-reviews__panel')];
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('.mo-bundle-reviews__tab');
          const index = this.tabs.indexOf(tab);
          if (index !== -1) this.activate(index);
        });
        this.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index === -1) return;
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(next, true);
        });
        this.activate(0);
      }

      activate(index, focus = false) {
        this.tabs.forEach((tab, position) => {
          const selected = position === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
        });
        if (focus) this.tabs[index].focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-weekends-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weekends-picker')) {
    customElements.define('weekends-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.boxes = [...this.querySelectorAll('input[type="checkbox"]')];
        this.form = this.querySelector('form');
        this.variantInput = this.form.querySelector('[name="id"]');
        this.button = this.form.querySelector('[type="submit"]');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        const selectedVariant = new URL(window.location.href).searchParams.get('variant');
        const initial = this.variants.find(v => String(v.id) === selectedVariant);
        if (initial) {
          const codes = initial.sku.split('-').slice(1);
          this.boxes.forEach(b => { b.checked = b.dataset.bookAvailable === 'true' && codes.includes(b.dataset.code); });
        }
        this.addEventListener('change', e => {
          if (e.target.type !== 'checkbox') return;
          if (this.boxes.filter(b => b.checked).length > 4) e.target.checked = false;
          this.update();
        });
        this.form.addEventListener('submit', e => {
          const chosen = this.boxes.filter(b => b.checked);
          const variant = this.match(chosen);
          if (chosen.length !== 4 || !variant || !variant.available) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
        this.update();
      }
      match(chosen) {
        const key = chosen.map(b => b.dataset.code).sort().join('|');
        return chosen.length === 4 ? this.variants.find(v => v.sku.split('-').slice(1).sort().join('|') === key) : null;
      }
      update() {
        const chosen = this.boxes.filter(b => b.checked);
        const variant = this.match(chosen);
        const ready = Boolean(variant && variant.available);
        this.boxes.forEach(b => { b.disabled = b.dataset.bookAvailable !== 'true' || (chosen.length === 4 && !b.checked); });
        this.querySelector('[data-count]').textContent = String(chosen.length);
        this.querySelector('[data-selection]').replaceChildren(...chosen.map(b => { const li = document.createElement('li'); li.textContent = b.dataset.title; return li; }));
        this.querySelector('[data-price]').textContent = variant ? this.money.format(variant.price / 100) : '—';
        this.variantInput.value = ready ? variant.id : '';
        this.variantInput.disabled = !ready;
        this.button.disabled = !ready;
        this.button.setAttribute('aria-disabled', String(!ready));
        this.querySelector('[data-button-text]').textContent = ready ? this.dataset.add : (variant ? this.dataset.unavailable : this.dataset.choose);
        this.querySelector('[data-status]').textContent = ready ? this.dataset.ready : (variant ? this.dataset.unavailable : this.dataset.choose);
        if (variant) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
